import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import ticketApi from "service/ticketApi";
import ChiTietCuaHangApi from "../../../service/chiTietCuaHangApi";
import { ThongTinNguoiTaoTicket } from "./ThongTinNguoiTaoTicket";
import { pushNotification } from "utils/notifications";
import { ThongTinTicket } from "./ThongTinTicket";
import { getListTicket } from "actions/Ticket";
import { getUserLogin } from "utils/user";
export const ThemMoiTicket = (props) => {
  const dispatch = useDispatch();
  const dataSearch = useSelector((state) => state.dataSearchTicket);
  const initDataAddAndEditnew = {
    KeyCode: "",
    NgayTao: "2024-12-16",
    TenNguoiTao: "",
    DienThoai: "",
    Email: getUserLogin().UserName,
    TieuDe: "",
    ChucNang: "CamDo",
    MoTa: "",
    ImageList: [],
    CuaHang: [],
  };

  const [dataAddAndEditNew, setDataAddAndEdit] = useState(
    initDataAddAndEditnew
  );

  const [imageTickets, setImageTickets] = useState([]);
  const [bDisable, setDisableButton] = useState(false);

  const currentForm = useForm();
  const { handleSubmit } = currentForm;

  useEffect(() => {
    ChiTietCuaHangApi.chiTietCuaHangHienTai().then((response) => {
      console.log(response);
       // Giả sử API trả về trường "TenNguoiTao"
     const tenNguoiTao = response.data.Name || "";
     const currentDate = new Date();
     const formattedDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${currentDate.getDate().toString().padStart(2, "0")}`
     // Cập nhật state với giá trị mới
     setDataAddAndEdit((prevState) => ({
       ...prevState,
       TenNguoiTao: tenNguoiTao,
       NgayTao: formattedDate,
       CongTy : "",
     }));
     });

    if (props.KeyCode > 0) {
      ticketApi.getOneDetailTicket(props.KeyCode).then((response) => {
        // // alert(response.data.ThongTinTicket.Code);
        // console.log(response.data.AnhTicket);
        setImageTickets(
          response.data.AnhTicket.map((item) => {
            return item.Url;
          })
        ); // set lạiđường dẫn url
        setDataAddAndEdit({
          ...dataAddAndEditNew,
          KeyCode: props.KeyCode,
          MaTicket: response.data.ThongTinTicket.Code,
          GhiChu: response.data.ThongTinTicket.Note,
          TinhTrangID: response.data.ThongTinTicket.TinhTrangTicket,
          KhoID: response.data.ThongTinTicket.StoreId,
          LoaiTicket: response.data.ThongTinTicket.LoaiTicket,
          TenTicket: response.data.ThongTinTicket.TenTicket,
          Options: response.data.ThuocTinh,
          ImageList: response.data.AnhTicket.map((item) => {
            return item.Url;
          }),
        });
      });
    }
  }, [props.KeyCode]);
  const updateTTTicket = (value) => {
    setDataAddAndEdit(value);
    // console.log(dataAddAndEditNew);
  };

  //Thông báo
  const initErrors = {
    tieuDe: "",
  };
  const [errors, setErrors] = useState(initErrors);
  const onSubmit = (dataTicket) => {

    if (dataAddAndEditNew.CongTy === "") {
      pushNotification("Nhập tên công ty, cửa hàng!","error","TOP_CENTER",2000);
      return;
    }
    if (dataAddAndEditNew.DienThoai === "") {
      pushNotification("Nhập số điện thoại!","error","TOP_CENTER",2000);
      return;
    }
    if (dataAddAndEditNew.TieuDe === "") {
      pushNotification("Nhập số tiêu đề!","error","TOP_CENTER",2000);
      return;
    }
    if (dataAddAndEditNew.Mota === "") {
      pushNotification("Nhập số mô tả!","error","TOP_CENTER",2000);
      return;
    }
    dataAddAndEditNew.ImageList = imageTickets.map(function (elem) {
      if (typeof elem.url !== "undefined") {
        return elem.url;
      } else {
        return elem;
      }
    });
    setDisableButton(true);
    ticketApi.saveTicket(dataAddAndEditNew).then((response) => {
      setDisableButton(false);
      if (response.status === 200) {
        dispatch(getListTicket(dataSearch));
        setDataAddAndEdit("", "", "", "", "", "", "", "", []);
        props.onHide();
        pushNotification(
          "Thêm mới ticket thành công",
          "success",
          "TOP_CENTER",
          2000
        );
      } else {
        pushNotification(
          response,
          "error",
          "TOP_CENTER",
          2000
        )
      }
    });
  };

  return (
    <Modal
      {...props}
      size="modal-new-size modal-new-size"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 className="modal-title  color7-bold" id="myModalLabel16">
          <span className="btn-icon-right">
            <img src="/app-assets/images/icon-them-moi-hop-dong-v2.png" />
          </span>{" "}
          {props.KeyCode > 0 ? "Sửa" : "Thêm mới"} ticket
        </h4>
        <button
          type="button"
          className="close-popup-new"
         onClick={props.onHide}
        >
          <img src="/app-assets/images/icon-dong-popup-v2.png" />
        </button>
      </Modal.Header>
      <form
        className="form tat-toan form-horizontal form-edit"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Modal.Body>
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse196"
                className="card-header"
                href="#collapse196"
                aria-expanded="true"
                aria-controls="collapse196"
              >
                <a
                  className="card-title lead info collapsed"
                  href={() => false}
                >
                  <h3>Thêm mới ticket</h3>
                </a>
              </div>
              <div
                id="collapse196"
                aria-labelledby="headingCollapse96"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="row">
                      <ThongTinNguoiTaoTicket
                        currentForm={currentForm}
                        datanew={dataAddAndEditNew}
                        update={updateTTTicket}
                        KeyCode={props.KeyCode}
                        errors={errors}
                        setErrors={setErrors}
                      />
                      <ThongTinTicket
                        currentForm={currentForm}
                        datanew={dataAddAndEditNew}
                        update={updateTTTicket}
                        AnhTicket={imageTickets}
                        updateAnhTicket={setImageTickets}
                        errors={errors}
                        setErrors={setErrors}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer button-popup-new-size">
          <button className="btn btn-new-main btn-checknew" type="submit"  disabled={bDisable}>
            <span className="btn-icon-left">
              <i className="mdi mdi-check"></i>
            </span>
            {props.KeyCode > 0 ? "Cập nhật" : "Gửi ticket"}
          </button>
         &nbsp;
          <a
            className="btn btn-new-main btn-closenew"
            data-dismiss="modal"
            href={() => false}
            onClick={props.onHide}
          >
            <span className="btn-icon-left">
              <i className="mdi mdi-close"></i>
            </span>{" "}
            Đóng
          </a>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
